import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { fadeIn } from '../variants';
import video1 from '../assets/videos/video1.mp4';
import blincyto from '../assets/videos/Blincyto.mp4';
import vdieo3 from '../assets/videos/vdieo3.mp4';
import EML from '../assets/eml-w.png';

const MediaItem = ({media, isVideo}) => (
  <div className="group relative overflow-hidden rounded-lg">
    <div className="cursor-pointer group-hover:bg-blue-900/70 w-full h-full absolute z-40 transition-all duration-300" />
    {isVideo ? (
      <video
        className="group-hover:scale-125 transition-all duration-500 w-full h-full object-cover"
        style={{width: '565px', height: '317px'}}
        autoPlay
        muted
        loop
      >
        <source src={media} type="video/mp4" />
        Tu navegador no soporta videos.
      </video>
    ) : (
      <img
        className="group-hover:scale-125 transition-all duration-500"
        src={media}
        alt="media"
        style={{width: '565px', height: '317px'}}
      />
    )}
    <div className="absolute -top-full w-[20%] group-hover:top-10 right-12 transition-all duration-500 z-50">
      <img src={EML} alt="eml" />
    </div>
    <div className="absolute -bottom-full left-12 group-hover:bottom-20 transition-all duration-700 z-50">
      <span className="text-[2rem] text-white" />
    </div>
  </div>
);

const Work = () => {
  const navigate = useNavigate();

  return (
    <section id="work" className="section">
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row gap-x-10">
          <motion.div
            variants={fadeIn('right', 0.3)}
            initial="hidden"
            whileInView="show"
            viewport={{once: false, amount: 0.3}}
            className="flex-1 flex flex-col gap-y-20 mb-10 lg:mb-0"
          >
            <div>
              <h2 className="h2 leading-tight text-secondBlue">
                Nuestro mundo Veeva <br /> y IQVIA
              </h2>
              <p className="max-w-sm mb-16 text-mainBlue">
                Desde Approved emails, ayudas visuales. Mira los ejemplos{' '}
                <strong className="text-mainYellow">
                  desarrollados por el equipo de EML
                </strong>
                .
              </p>
              <button
                onClick={() => navigate('/veeva-projects')}
                className="btn btn-sm cursor-pointer"
              >
                Ver todos los proyectos
              </button>
            </div>

            <MediaItem media={video1} isVideo />
          </motion.div>

          <motion.div
            variants={fadeIn('left', 0.3)}
            initial="hidden"
            whileInView="show"
            viewport={{once: false, amount: 0.3}}
            className="flex-1 flex flex-col justify-between gap-y-10"
          >
            <MediaItem media={vdieo3} isVideo />
            <MediaItem media={blincyto} isVideo />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Work;